/**
 * `vite` (dev) fala com o mock, a menos que `.env.local` peça `http`.
 * `vite build` (produção) fala com a API, a menos que `VITE_API_MODE=mock`.
 *
 * O Docker não copia `.env.local` (gitignored). Sem este padrão, a imagem
 * do jogo ia ao ar com o mock (Hellfire de seed e personagens de mentira).
 */
export const useHttpApi =
  import.meta.env.VITE_API_MODE === 'http'
  || (import.meta.env.PROD && import.meta.env.VITE_API_MODE !== 'mock');
